import { useState, useEffect } from "react";
import type { Brand, Company, Category } from "./types";

interface ContentData {
  brands: Brand[];
  companies: Company[];
  categories: Category[];
}

export function useContentData() {
  const [data, setData] = useState<ContentData>({
    brands: [],
    companies: [],
    categories: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Skip fetch during build time (when window is undefined)
    if (typeof window === 'undefined') {
      setLoading(false);
      return;
    }

    async function fetchContent() {
      try {
        const response = await fetch("/api/content");
        if (!response.ok) {
          throw new Error("Failed to fetch content");
        }
        const contentData = await response.json();
        setData(contentData);
      } catch (err) {
        setError(err instanceof Error ? err.message : "Unknown error");
      } finally {
        setLoading(false);
      }
    }

    fetchContent();
  }, []);

  return { data, loading, error };
}
